module.exports = __webpack_public_path__ + "img/alfa.ddc04822.svg";